import React from "react";

import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Trans, withTranslation } from "react-i18next";
import i18next from "i18next";
import i18n from "../../../i18n";
import { saveAs } from "file-saver";

import {
  Collapse,
  Callout,
  Button,
  Switch,
  Icon,
  FormGroup,
  InputGroup,
  HTMLSelect,
  Classes,
  Dialog,
  Tag,
  Drawer,
  DrawerSize,
  NumericInput,
  RadioGroup,
  Radio,
} from "@blueprintjs/core";

import EquipmentDetail from "../EquipmentDetail";
import { ParkSelect, parkLookup } from "../../Structure/ParkSelector";
import { EquipmentSelect } from "../../Structure/EquipmentSelector";
import {
  authenticatedGetFetch,
  getBackendRoute,
} from "../../../utils/AuthenticatedFetch";
import { Cell } from "@blueprintjs/table";
import { DateInput3, TimePrecision } from "@blueprintjs/datetime2";
import { Col_Infosup } from "./Col_Infosup";
import { getExtension, userIcons } from "../../../utils/mef";
import { TicketManagement } from "../UserManagement/TicketManagement";
import { front_basename } from "../../..";
import { useParams } from "react-router-dom";

const EXPORT_MAX = 100000;

function WsState(props) {
  const stateStrings = [
    <Trans>connecting, please wait</Trans>,
    <Trans>synchronized in real time</Trans>,
    <Trans>disconnected</Trans>,
    <Trans>disconnected</Trans>,
  ];
  const stateIcons = ["help", "full-circle", "offline", "offline"];
  const stateIntent = ["warning", "success", "danger", "danger"];
  if (props.ws !== undefined)
    return (
      <span>
        <Icon
          icon={stateIcons[props.ws.readyState]}
          intent={stateIntent[props.ws.readyState]}
        />{" "}
        {stateStrings[props.ws.readyState]}
      </span>
    );
  else
    return (
      <span>
        <Icon icon={stateIcons[3]} intent={stateIntent[3]} /> {stateStrings[3]}
      </span>
    );
}

class EventFlow extends React.Component {
  constructor(props) {
    super();
    this.state = {
      events: [],
      currentPage: 0,
      isOpen: false,
      realTime: props.realTime !== undefined ? props.realTime : true,
      static: props.static !== undefined && props.static,
      loading: true,
      pageSize: props.pageSize !== undefined ? props.pageSize : 20,
      columnWidths: [0, 0, 0, 0, 0],
      isExportOpen: false,
      exporting: false,
      exportFormat: "excel",
      openFiltering: false,
      filteringData: [],
      filterId: -1,
      parkLookup: parkLookup(),
      plateTolerance: "-1",
    };

    this.handleOpenClose = this.handleOpenClose.bind(this);
    this.Col_Infosup = Col_Infosup.bind(this);
  }
  ac = new AbortController();

  clamp(val, min, max) {
    if (val == null) return val;
    else return Math.min(Math.max(val, min), max);
  }

  componentDidMount() {
    authenticatedGetFetch(
      "/devices",
      (response) => {
        const lookup = {};
        for (const device of response) {
          lookup[device.id] = (
            <span>
              {device.id} - {device.name}
            </span>
          );
          lookup[device?.park?.server?.id + "_" + device.id] = (
            <span>
              {device.id} - {device.name}
            </span>
          );
        }
        this.setState({ deviceLookup: lookup }, () => {
          // set columns once lookups are loaded, else it's not used
          if (this.state.static) {
            this.setState({ isOpen: true });
            if (this.state.realTime) this.handleOpenClose(true);
          } else this.setState({ isOpen: false, loading: false });
        });
      },
      null,
      this.ac.signal
    );

    try {
      const conf = localStorage.getItem("event_filtering");
      const filteringData = JSON.parse(conf ?? []);
      filteringData.unshift({ id: -1, name: "no filtre" });
      this.setState({ filteringData: filteringData });
    } catch (error) {
      console.log("issue on event_filtering");
    }
  }

  componentWillUnmount() {
    //cancel all running queries
    this.ac.abort();
    //close websocket when component unmount
    if (this.client !== undefined) this.client.close();
  }

  handleFlowMessage(message) {
    try {
      const parsedmsg = JSON.parse(message.data);
      //add new event at the beginning and remove the last one
      if (this.state.filterId >= 0) {
        const filter = this.state.filteringData.find(
          (item) => item.id === this.state.filterId
        );
        if (
          !(
            parsedmsg["event"]["id"] === undefined ||
            (filter &&
              filter.eventsList.includes(parsedmsg["event"]["id"].toString()))
          )
        )
          return;
      }

      // pop last event
      this.events.pop();
      this.events.pop();
      this.events.pop();

      // avoid pop if hidden columns
      if (!this.props.equipment && !this.state.park) this.events.pop();
      if (!this.props.equipment) this.events.pop();

      this.events = [
        <Cell
          key={parsedmsg["DAYEVEN"] + parsedmsg["ID"] + "11"}
          className="eventCell"
        >
          {new Date(parsedmsg["DAYEVEN"]).toLocaleString(i18next.language)}
        </Cell>,
        <Cell
          intent={parsedmsg["event"]["intent"]}
          key={parsedmsg["DAYEVEN"] + parsedmsg["ID"] + "22"}
        >
          <Trans>{"event" + parsedmsg["event"]["id"]}</Trans>
        </Cell>,

        this.props.equipment > 0 ? null : (
          <Cell
            key={parsedmsg["DAYEVEN"] + parsedmsg["ID"] + "33"}
            className="eventCell"
          >
            {this.state.parkLookup[parsedmsg["NUMEPARC"]] ||
              parsedmsg["NUMEPARC"]}
          </Cell>
        ),
        this.props.equipment > 0 || this.state.park > 0 ? null : (
          <Cell
            key={parsedmsg["DAYEVEN"] + parsedmsg["ID"] + "44"}
            className="eventCell"
          >
            <EquipmentDetail
              equipmentId={`${parsedmsg["NUMEEQUI"]}_${parsedmsg?.syncServerId}`}
              text={
                this.state.deviceLookup[
                  parsedmsg?.syncServerId + "_" + parsedmsg["NUMEEQUI"]
                ] || parsedmsg["NUMEEQUI"]
              }
            />
          </Cell>
        ),
        <this.Col_Infosup
          key={parsedmsg["DAYEVEN"] + parsedmsg["ID"] + "55"}
          className="eventCell"
          {...parsedmsg}
          onOpen={() =>
            this.setState({
              ticketDetails: {
                server: parsedmsg?.syncServerId,
                id: parsedmsg?.ticketId,
              },
            })
          }
        />,
        ...this.events,
      ];

      this.setState({
        events: [
          parsedmsg,
          ...this.state.events.slice(0, this.state.pageSize - 1),
        ],
      });
    } catch (e) {
      console.error(
        "error when receiving event from eventFlow:",
        e,
        message.data
      );
    }
  }

  handleOpenClose(refresh = false) {
    this.ac.abort();
    this.ac = new AbortController();
    if (this.state.isOpen && !refresh) {
      this.setState({ isOpen: false, loading: true }, () => {
        // close
        if (this.client !== undefined) this.client.close();
        this.setState({ events: [], loading: false });
      });
    } else {
      // open or refresh
      var params = { group: this.props.groupId || 0 };

      if (this.props.park >= 0) params["park"] = this.props.park;
      if (this.state.park >= 0) params["park"] = this.state.park;

      if (this.props.equipment > 0) params["equipment"] = this.props.equipment;
      else if (this.state.device > 0) params["equipment"] = this.state.device;
      if (this.props.srv > 0) params["srvfilter"] = this.props.srv;

      this.state.subscriberId &&
        (params["subscriberId"] = this.state.subscriberId);
      this.state.ccToken && (params["ccToken"] = this.state.ccToken);
      this.state.operationId &&
        (params["operationId"] = this.state.operationId);

      this.state.bookingId && (params["bookingId"] = this.state.bookingId);

      this.state.plate && (params["plate"] = this.state.plate);
      this.state.plateTolerance &&
        (params["plateTolerance"] = this.state.plateTolerance);

      params["pageSize"] = this.state.pageSize;

      params["page"] = this.state.currentPage;

      if (this.state.filterId !== -1) params["filterId"] = this.state.filterId;

      this.state.from &&
        (params["from"] = new Date(this.state.from).toISOString());
      this.state.to && (params["to"] = new Date(this.state.to).toISOString());

      this.setState({ params: params }); // used for file export

      if (this.state.realTime) {
        // get initial data
        this.setState({ loading: true }, () => {
          authenticatedGetFetch(
            "/supervision/flow/history?" +
              new URLSearchParams({ ...params, count: false }),
            (response) => {
              this.setState(
                {
                  events: response.data,
                  currentPage: response.page,
                  totalCount: response.totalCount,
                  resized: false,
                },
                () => {
                  //open and handle websocket
                  this.events = this.state.events.flatMap((item) => [
                    <Cell
                      key={item["DAYEVEN"] + item["ID"] + "11"}
                      className="eventCell"
                    >
                      {new Date(item["DAYEVEN"]).toLocaleString(
                        i18next.language
                      )}
                    </Cell>,
                    <Cell
                      intent={item["event"]["intent"]}
                      key={item["DAYEVEN"] + item["ID"] + "22"}
                      className="eventCell"
                    >
                      <Trans>{"event" + item["event"]["id"]}</Trans>
                    </Cell>,
                    this.props.equipment > 0 ? null : (
                      <Cell
                        key={item["DAYEVEN"] + item["ID"] + "33"}
                        className="eventCell"
                      >
                        {this.state.parkLookup[item["NUMEPARC"]] ||
                          item["NUMEPARC"]}
                      </Cell>
                    ),
                    this.props.equipment > 0 || this.state.park > 0 ? null : (
                      <Cell
                        key={item["DAYEVEN"] + item["ID"] + "44"}
                        className="eventCell"
                      >
                        <EquipmentDetail
                          equipmentId={`${item["NUMEEQUI"]}_${item?.syncServerId}`}
                          text={
                            this.state.deviceLookup[
                              item["syncServerId"] + "_" + item["NUMEEQUI"]
                            ] || item["syncServerId"] + "_" + item["NUMEEQUI"]
                          }
                        />
                      </Cell>
                    ),
                    <this.Col_Infosup
                      key={item["DAYEVEN"] + item["ID"] + "55"}
                      className="eventCell"
                      {...item}
                      onOpen={() =>
                        this.setState({
                          ticketDetails: {
                            server: item?.syncServerId,
                            id: item?.ticketId,
                          },
                        })
                      }
                    />,
                  ]);

                  this.setState({ isOpen: true }, () => {
                    if (this.client !== undefined) {
                      this.client.close();
                      delete this.client;
                    }

                    this.client = new W3CWebSocket(
                      getBackendRoute("WS") +
                        "/supervision/flow?" +
                        new URLSearchParams(params),
                      ["Bearer", localStorage.getItem("token")]
                    );

                    this.client.onopen = () => {
                      //console.log("WebSocket Client Connected");
                      this.setState({ loading: false, isOpen: true });
                    };

                    //this.client.onclose = () => console.log("WebSocket Client Disconnected");

                    this.client.onmessage = (message) =>
                      this.handleFlowMessage(message);
                  });
                }
              );
            },
            null,
            this.ac.signal
          );
        });
      } else {
        if (this.client !== undefined) this.client.close();

        authenticatedGetFetch(
          "/supervision/flow/history?" +
            new URLSearchParams({ ...params, count: params["page"] === 0 }),
          (response) => {
            this.events = response.data.flatMap((item) => [
              <Cell
                key={item["DAYEVEN"] + item["ID"] + "11"}
                className="eventCell"
              >
                {new Date(item["DAYEVEN"]).toLocaleString(i18next.language)}
              </Cell>,
              <Cell
                intent={item["event"]["intent"]}
                key={item["DAYEVEN"] + item["ID"] + "22"}
              >
                <Trans>{"event" + item["event"]["id"]}</Trans>
              </Cell>,
              this.props.equipment > 0 || this.state.park > 0 ? null : (
                <Cell
                  key={item["DAYEVEN"] + item["ID"] + "33"}
                  className="eventCell"
                >
                  {this.state.parkLookup[item["NUMEPARC"]] || item["NUMEPARC"]}
                </Cell>
              ),
              this.props.equipment > 0 ? null : (
                <Cell
                  key={item["DAYEVEN"] + item["ID"] + "44"}
                  className="eventCell"
                >
                  <EquipmentDetail
                    equipmentId={`${item["NUMEEQUI"]}_${item?.syncServerId}`}
                    text={
                      this.state.deviceLookup[
                        item["syncServerId"] + "_" + item["NUMEEQUI"]
                      ] || item["NUMEEQUI"]
                    }
                  />
                </Cell>
              ),
              <this.Col_Infosup
                key={item["DAYEVEN"] + item["ID"] + "55"}
                className="eventCell"
                {...item}
                onOpen={() =>
                  this.setState({
                    ticketDetails: {
                      server: item?.syncServerId,
                      id: item?.ticketId,
                    },
                  })
                }
              />,
            ]);
            this.setState({
              events: response.data,
              page: response.page,
              totalCount:
                response.totalCount >= 0
                  ? response.totalCount
                  : this.state.totalCount,
              isOpen: true,
            });
          },
          null,
          this.ac.signal
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.ccId !== this.props.ccId ||
      prevProps.licensePlate !== this.props.licensePlate ||
      prevProps.subscriberId !== this.props.subscriberId ||
      prevProps.park !== this.props.park ||
      prevProps.equipment !== this.props.equipment ||
      (prevProps.interval !== undefined &&
        prevProps.interval[0] !== this.props.interval[0]) ||
      (prevProps.interval !== undefined &&
        prevProps.interval[1] !== this.props.interval[1])
    ) {
      this.handleOpenClose(true);
    }
  }

  ccHash(ccNumber) {
    let hash = 0;
    for (var i = 0; i < ccNumber.length; i++) {
      hash += ccNumber.charCodeAt(i);
      hash += (hash << 10) >>> 0;
      hash ^= hash >>> 6; // warning: use >>> instead of >> cause number is signed
    }
    hash += (hash << 3) >>> 0;
    hash ^= hash >>> 11; // warning: use >>> instead of >> cause number is signed
    hash += (hash << 15) >>> 0;
    return hash === 0 ? "" : hash.toString(16).toUpperCase(); // need to take absolute value ?
  }

  getfilterTitle() {
    const index = this.state.filteringData.findIndex(
      (item) => item.id === this.state.filterId
    );
    if (index === -1) return "";
    else return this.state.filteringData[index].name;
  }

  handleGenerate = () => {
    this.setState({ generating: true });
    authenticatedGetFetch(
      `/supervision/history/export?format=${this.state.exportFormat}&` +
        new URLSearchParams(this.state.params),
      (data) => {
        console.log(data.length);
        saveAs(
          new Blob([data]),
          "EventHistory-" +
            (this.state.params?.fr !== undefined
              ? new Date(this.state.params?.fr).toLocaleString(i18next.language)
              : "") +
            "-" +
            (this.state.params?.to !== undefined
              ? new Date(this.state.params.to).toLocaleString(i18next.language)
              : new Date().toLocaleString(i18next.language)) +
            `.${getExtension(this.state.exportFormat)}`
        );
        this.setState({ generating: false, progress: 1 });
      },
      undefined,
      undefined,
      () => {
        this.setState({ generating: false });
      },
      true
    );
  };

  render() {
    const content = (
      <>
        {this.state.isOpen && (
          <HTMLSelect
            options={this.state.filteringData.map((filter) => {
              return { value: filter.id, label: i18n.t(filter.name) };
            })}
            onChange={(selection) =>
              this.setState({ filterId: selection.target.value }, () =>
                this.handleOpenClose(true)
              )
            }
          />
        )}

        {this.state.isOpen && this.props.realTime === undefined && (
          <Switch
            checked={this.state.realTime}
            label={i18n.t("real time")}
            onChange={(cb) => {
              this.ac.abort();
              this.ac = new AbortController();
              this.setState({ realTime: cb.target.checked }, () => {
                this.handleOpenClose(true);
              });
            }}
          />
        )}

        {this.state.isOpen &&
          this.props.enableSearch !== undefined &&
          this.props.enableSearch === true &&
          this.state.realTime === false && (
            <div>
              <div className="flexbox-left">
                {/* search by license plate */}
                <div>
                  <FormGroup
                    label={<Trans>search a plate</Trans>}
                    labelFor="plate"
                  >
                    <InputGroup
                      type="text"
                      id="plate"
                      leftIcon="widget-button"
                      onChange={(ti) => {
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => {
                          this.setState(
                            {
                              plate: ti.target.value
                                .replace(/[^0-9a-z]/gi, "")
                                .toUpperCase(),
                              waiting: false,
                            },
                            () => {
                              this.handleOpenClose(true);
                            }
                          );
                        }, 1000);
                      }}
                    />
                  </FormGroup>

                  {this.state.plate && (
                    <>
                      <RadioGroup
                        selectedValue={
                          ""+(this.state.plateTolerance > 1
                            ? 1
                            : this.state.plateTolerance)
                        }
                        onChange={(rad) => {
                          this.setState(
                            { plateTolerance: rad.target.value },
                            () => this.handleOpenClose(true)
                          );
                        }}
                      >
                        <Radio
                          label={<Trans>plate contains</Trans>}
                          value={"-1"}
                        />
                        <Radio
                          label={<Trans>exact matching</Trans>}
                          value={"0"}
                        />
                        <Radio
                          label={<Trans>given tolerence:</Trans>}
                          value={"1"}
                        />
                      </RadioGroup>
                      {this.state.plateTolerance > 0 && (
                        <FormGroup
                          label={<Trans>plate tolerance</Trans>}
                          labelFor="plateTolerance"
                        >
                          <NumericInput
                            id="plateTolerance"
                            min={0}
                            max={5}
                            leftIcon="widget-button"
                            onValueChange={(valueAsNumber) => {
                              this.setState(
                                { plateTolerance: valueAsNumber },
                                () => this.handleOpenClose(true)
                              );
                            }}
                          />
                        </FormGroup>
                      )}
                    </>
                  )}
                </div>

                {/* credit card number */}
                <FormGroup
                  label={<Trans>search a credit card</Trans>}
                  labelFor="ccNumber"
                >
                  <InputGroup
                    type="text"
                    id="ccNumber"
                    leftIcon={userIcons[1]}
                    onChange={(ti) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.setState(
                          {
                            ccToken: this.ccHash(
                              ti.target.value.replace(/[^0-9a-z]/gi, "")
                            ),
                            waiting: false,
                          },
                          () => {
                            this.handleOpenClose(true);
                          }
                        );
                      }, 1000);
                    }}
                  />
                </FormGroup>

                {/* credit subscriber's id */}
                <FormGroup
                  label={<Trans>search a subscriber</Trans>}
                  labelFor="subscriberId"
                >
                  <InputGroup
                    type="text"
                    id="subscriberId"
                    leftIcon="person"
                    onChange={(ti) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.setState(
                          {
                            subscriberId: ti.target.value.replace(
                              /[^0-9a-z]/gi,
                              ""
                            ),
                            waiting: false,
                          },
                          () => {
                            this.handleOpenClose(true);
                          }
                        );
                      }, 1000);
                    }}
                  />
                </FormGroup>

                {/* credit subscriber's id */}
                <FormGroup
                  label={<Trans>operation id</Trans>}
                  labelFor="operationId"
                >
                  <InputGroup
                    type="text"
                    id="operationId"
                    leftIcon="dollar"
                    onChange={(ti) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.setState(
                          {
                            operationId: ti.target.value.replace(
                              /[^0-9]/gi,
                              ""
                            ),
                            waiting: false,
                          },
                          () => {
                            this.handleOpenClose(true);
                          }
                        );
                      }, 1000);
                    }}
                  />
                </FormGroup>

                {/* booking id */}
                <FormGroup
                  label={<Trans>search a booking</Trans>}
                  labelFor="booking"
                >
                  <InputGroup
                    type="text"
                    id="booking"
                    leftIcon="book"
                    onChange={(ti) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.setState(
                          {
                            bookingId: ti.target.value.replace(
                              /[^0-9a-z]/gi,
                              ""
                            ),
                            waiting: false,
                          },
                          () => {
                            this.handleOpenClose(true);
                          }
                        );
                      }, 1000);
                    }}
                  />
                </FormGroup>

                <FormGroup label={<Trans>from</Trans>} labelFor="from">
                  <DateInput3
                    id="from"
                    formatDate={(date) =>
                      new Date(date).toLocaleString(i18next.language)
                    }
                    onChange={(date) => {
                      this.setState({ from: date }, () => {
                        this.handleOpenClose(true);
                      });
                    }}
                    value={this.state.from}
                    parseDate={(str) => new Date(str)}
                    highlightCurrentDay={true}
                    timePrecision={TimePrecision.MINUTE}
                    showTimezoneSelect={false}
                    showActionsBar={true}
                    todayButtonText={<Trans>today</Trans>}
                    clearButtonText={<Trans>clear</Trans>}
                  />
                </FormGroup>
                <FormGroup label={<Trans>to</Trans>} labelFor="to">
                  <DateInput3
                    id="to"
                    formatDate={(date) =>
                      new Date(date).toLocaleString(i18next.language)
                    }
                    onChange={(date) => {
                      this.setState({ to: date }, () => {
                        this.handleOpenClose(true);
                      });
                    }}
                    value={this.state.to}
                    parseDate={(str) => new Date(str)}
                    highlightCurrentDay={true}
                    timePrecision={TimePrecision.MINUTE}
                    showTimezoneSelect={false}
                    showActionsBar={true}
                    todayButtonText={<Trans>today</Trans>}
                    clearButtonText={<Trans>clear</Trans>}
                  />
                </FormGroup>

                <HTMLSelect
                  options={[
                    { value: "all", label: i18n.t("all the equipments") },
                    { value: "park", label: i18n.t("for a park") },
                    { value: "equipment", label: i18n.t("for an equipment") },
                  ]}
                  onChange={(s) =>
                    this.setState(
                      {
                        searchFor: s.target.value,
                        device: undefined,
                        park: undefined,
                      },
                      () => this.handleOpenClose(true)
                    )
                  }
                  value={this.state.searchFor}
                />

                {this.state.searchFor === "park" && (
                  <ParkSelect
                    onSelect={(id) => {
                      this.setState({ park: id }, () => {
                        this.handleOpenClose(true);
                      });
                    }}
                  />
                )}

                {this.state.searchFor === "equipment" && (
                  <EquipmentSelect
                    onSelect={(id) => {
                      this.setState({ device: id }, () => {
                        this.handleOpenClose(true);
                      });
                    }}
                  />
                )}
              </div>
            </div>
          )}

        {this.state.realTime && this.state.isOpen && (
          <WsState ws={this.client} />
        )}

        {this.state.isOpen ? (
          <div style={{ overflowX: "scroll" }}>
            <div
              className={
                this.state.park > 0
                  ? "eventflow_park_filtered"
                  : this.props.equipment > 0
                  ? "eventflow_device_filtered"
                  : "eventflow"
              }
              style={{ minWidth: "100ch" }}
            >
              <Cell>
                <Trans>date</Trans>
              </Cell>
              <Cell>
                <Trans>event</Trans>
              </Cell>
              {this.props.equipment > 0 ||
              this.state.equipment > 0 ||
              this.state.park > 0 ? null : (
                <Cell>
                  <Trans>park</Trans>
                </Cell>
              )}
              {this.props.equipment > 0 ? null : (
                <Cell>
                  <Trans>device</Trans>
                </Cell>
              )}
              <Cell>
                <Trans>infosup</Trans>
              </Cell>
              {this.events}
            </div>
          </div>
        ) : null}

        {/* pagination */}
        <div className="flexbox-center-large">
          <HTMLSelect
            options={[
              { value: 20 },
              { value: 30 },
              { value: 50 },
              { value: 100 },
              { value: 200 },
            ]}
            onChange={(s) => {
              this.setState({ pageSize: s.target.value }, () =>
                this.handleOpenClose(true)
              );
            }}
            value={this.state.pageSize}
          />
          {!this.state.realTime && (
            <>
              <div>
                {/* first page */}
                <Button
                  minimal={true}
                  icon="double-chevron-left"
                  onClick={() => {
                    if (this.state.currentPage > 0) {
                      this.ac.abort();
                      this.setState({ currentPage: 0 }, () =>
                        this.handleOpenClose(true)
                      );
                    }
                  }}
                />

                {/* previous page */}
                <Button
                  minimal={true}
                  icon="chevron-left"
                  onClick={() => {
                    if (this.state.currentPage > 0) {
                      this.ac.abort();
                      this.setState(
                        { currentPage: this.state.currentPage - 1 },
                        () => this.handleOpenClose(true)
                      );
                    }
                  }}
                />

                {/* current data display */}
                <Tag large={true}>
                  {this.state.currentPage * this.state.pageSize + 1} -{" "}
                  {Math.min(
                    (this.state.currentPage + 1) * this.state.pageSize,
                    this.state.totalCount
                  )}{" "}
                  / {this.state.totalCount}
                </Tag>

                {/* next page */}
                <Button
                  minimal={true}
                  icon="chevron-right"
                  onClick={() => {
                    const lastPage =
                      Math.ceil(this.state.totalCount / this.state.pageSize) -
                      1;
                    if (this.state.currentPage < lastPage) {
                      this.ac.abort();
                      this.setState(
                        { currentPage: this.state.currentPage + 1 },
                        () => this.handleOpenClose(true)
                      );
                    }
                  }}
                />

                {/* last page */}
                <Button
                  minimal={true}
                  icon="double-chevron-right"
                  onClick={() => {
                    const lastPage =
                      Math.ceil(this.state.totalCount / this.state.pageSize) -
                      1;
                    if (this.state.currentPage < lastPage) {
                      this.ac.abort();
                      this.setState({ currentPage: lastPage }, () =>
                        this.handleOpenClose(true)
                      );
                    }
                  }}
                />
              </div>
              {this.state.realTime !== undefined && !this.state.realTime && (
                <div>
                  <Button
                    text={<Trans>export to excel</Trans>}
                    onClick={() => this.setState({ isExportOpen: true })}
                    icon="th"
                  />
                  <Dialog
                    isOpen={this.state.isExportOpen}
                    onClose={() => this.setState({ isExportOpen: false })}
                    style={{ transition: "none" }}
                    title={<Trans>export to excel</Trans>}
                    icon="th"
                  >
                    <div className={Classes.DIALOG_BODY}>
                      <HTMLSelect
                        options={[
                          { label: "Excel", value: "excel" },
                          { label: "CSV", value: "csv" },
                          { label: "HTML", value: "html" },
                        ]}
                        onChange={(s) =>
                          this.setState({ exportFormat: s.target.value })
                        }
                      />
                      {this.state.totalCount > EXPORT_MAX && (
                        <Callout
                          intent="warning"
                          title={<Trans>data export will be truncated</Trans>}
                        >
                          <Trans>can't export more than</Trans> {EXPORT_MAX}{" "}
                          <Trans>rows</Trans>
                        </Callout>
                      )}

                      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                          icon="download"
                          loading={this.state.generating}
                          onClick={this.handleGenerate}
                          text={<Trans>download</Trans>}
                        />
                      </div>
                    </div>
                  </Dialog>
                </div>
              )}
            </>
          )}
        </div>
      </>
    );

    return (
      <Callout
        title={
          <div className="flexbox-center-large">
            <div>
              {this.props.realTime ? (
                <Trans>event flow</Trans>
              ) : (
                <Trans>event history</Trans>
              )}{" "}
              {this.props.static && this.props.realTime && (
                <Button
                  onClick={() => {
                    const _window = window.open(
                      front_basename +
                        "/eventflow/" +
                        (this.props.groupId || 0),
                      "Event Flow",
                      "toolbar=no,location=no,status=no,menubar=no"
                    );
                    _window.focus();
                  }}
                  icon="modal"
                />
              )}
              {/* Event filters settings, available only for admin */}
              {localStorage.getItem("perm_admin") && (
                <Button
                  icon="cog"
                  onClick={() => {
                    const _window = window.open(
                      front_basename + "/settings/events",
                      "Event Flow",
                      "toolbar=no,location=no,status=no,menubar=no"
                    );
                    _window.focus();
                  }}
                />
              )}
            </div>
            {this.props.closable && (
              <Button
                onClick={() => window.close()}
                icon="cross"
                minimal={true}
              />
            )}
          </div>
        }
      >
        {!this.props.static && (
          <div className="flexbox-left">
            <Button
              onClick={() => this.handleOpenClose()}
              icon="history"
              loading={this.state.loading}
            >
              <>
                {this.state.isOpen ? <Trans>hide</Trans> : <Trans>show</Trans>}{" "}
                {this.props.realTime ? (
                  <Trans>event flow</Trans>
                ) : (
                  <Trans>event history</Trans>
                )}
              </>
            </Button>
          </div>
        )}

        {this.props.position === undefined && (
          <Collapse isOpen={this.state.isOpen}>{content}</Collapse>
        )}

        {this.props.position !== undefined && (
          <Drawer
            isOpen={this.state.isOpen}
            canEscapeKeyClose={true}
            onClose={() => this.setState({ isOpen: false })}
            position={this.props.position}
            size={DrawerSize.STANDARD}
          >
            {content}
          </Drawer>
        )}

        <TicketManagement
          id={this.state.ticketDetails?.id}
          server={this.state.ticketDetails?.server}
          isOpen={this.state.ticketDetails !== undefined}
          onClose={() => this.setState({ ticketDetails: undefined })}
          parkLookup={this.state.parkLookup}
          deviceLookup={this.state.deviceLookup}
        />
      </Callout>
    );
  }
}

export function EVHandler(props) {
  const { groupId } = useParams();
  return <EventFlow {...props} key={groupId} groupId={groupId} />;
}

export default withTranslation()(EVHandler);
